// Alert attention helpers: synthesized chime (Web Audio, no asset), tab-title flash,
// optional browser notification. All gated by a user preference in localStorage.
const KEY = "apx:alert-sound";
let ctx = null;

export const soundEnabled = () => localStorage.getItem(KEY) !== "off";
export const setSoundEnabled = (on) => { localStorage.setItem(KEY, on ? "on" : "off"); window.dispatchEvent(new Event("apx:sound-pref")); };

const getCtx = () => {
  if (!ctx) {
    const AC = window.AudioContext || window.webkitAudioContext;
    if (!AC) return null;
    ctx = new AC();
  }
  return ctx;
};

// Browsers require a user gesture before audio can play — call once from a click handler.
export const unlockAudio = () => { const c = getCtx(); if (c && c.state === "suspended") c.resume().catch((e) => console.warn("[apex] request failed:", e?.message || e)); };

export const playChime = (force = false) => {
  if (!force && !soundEnabled()) return false;
  const c = getCtx();
  if (!c) return false;
  if (c.state === "suspended") c.resume().catch((e) => console.warn("[apex] request failed:", e?.message || e));
  const now = c.currentTime;
  const master = c.createGain();
  master.gain.setValueAtTime(0.0001, now);
  master.gain.exponentialRampToValueAtTime(0.18, now + 0.02);
  master.gain.exponentialRampToValueAtTime(0.0001, now + 1.6);
  master.connect(c.destination);
  // Two soft bell partials: E6 then B6, slight detune for warmth
  [[1318.5, 0], [1975.5, 0.14]].forEach(([f, delay]) => {
    const o = c.createOscillator();
    const g = c.createGain();
    o.type = "sine";
    o.frequency.setValueAtTime(f, now + delay);
    o.detune.setValueAtTime(4, now + delay);
    g.gain.setValueAtTime(0.0001, now + delay);
    g.gain.exponentialRampToValueAtTime(1, now + delay + 0.015);
    g.gain.exponentialRampToValueAtTime(0.0001, now + delay + 1.3);
    o.connect(g); g.connect(master);
    o.start(now + delay); o.stop(now + delay + 1.4);
  });
  return true;
};

let titleTimer = null, baseTitle = null;
export const flashTitle = (msg) => {
  if (document.visibilityState === "visible") return;
  if (!baseTitle) baseTitle = document.title;
  let on = false;
  clearInterval(titleTimer);
  titleTimer = setInterval(() => { on = !on; document.title = on ? `🔔 ${msg}` : baseTitle; }, 1000);
  const stop = () => { clearInterval(titleTimer); titleTimer = null; document.title = baseTitle; document.removeEventListener("visibilitychange", onVis); };
  const onVis = () => { if (document.visibilityState === "visible") stop(); };
  document.addEventListener("visibilitychange", onVis);
};

export const notifyBrowser = (title, body) => {
  if (!("Notification" in window) || Notification.permission !== "granted" || document.visibilityState === "visible") return;
  try { new Notification(title, { body, icon: "/favicon.ico", tag: "apexai-alert" }); } catch (e) { console.warn("[apex] ignored:", e); }
};

export const requestBrowserNotifications = async () => {
  if (!("Notification" in window)) return "unsupported";
  if (Notification.permission === "default") return Notification.requestPermission();
  return Notification.permission;
};

// One call site for "an alert fired": chime + bell flash + title flash + browser notification.
export const announceAlert = (title, body) => {
  playChime();
  flashTitle(title);
  notifyBrowser(title, body);
  window.dispatchEvent(new CustomEvent("apx:alert-fired", { detail: { title, body } }));
  window.dispatchEvent(new Event("apx:notifications-changed"));
};
